import { render, staticRenderFns } from "./saml_authorize.vue.js?vue&type=template&id=382aa1e4!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./saml_authorize.vue?vue&type=template&id=382aa1e4"
import script from "./saml_authorize.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./saml_authorize.vue?vue&type=script&lang=js"
export * from "./saml_authorize.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./saml_authorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382aa1e4')) {
      api.createRecord('382aa1e4', component.options)
    } else {
      api.reload('382aa1e4', component.options)
    }
    module.hot.accept("./saml_authorize.vue.js?vue&type=template&id=382aa1e4!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./saml_authorize.vue?vue&type=template&id=382aa1e4", function () {
      api.rerender('382aa1e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ee/app/assets/javascripts/saml_sso/components/saml_authorize.vue"
export default component.exports